import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LeaveService } from 'src/app/rest_services/msLeaveServices/leave.service';
import { UserService } from 'src/app/rest_services/user.service';

@Component({
  selector: 'app-absence-detail',
  templateUrl: './absence-detail.component.html',
  styleUrls: ['./absence-detail.component.css']
})
export class AbsenceDetailComponent implements OnInit {

  detailLoading: boolean = true;
  leave: any = { };
  id: any;
  constructor(
    private leaveService : LeaveService,
    private route: ActivatedRoute,
    private userService : UserService
  ) { }

  fullname: any = '';
  ngOnInit(): void {

    if(localStorage.getItem("role")!=undefined) {
      this.fullname =localStorage.getItem("fullname");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.fullname =sessionStorage.getItem("fullname");
    }

    this.id= this.route.snapshot.paramMap.get('id');
    this.getLeave();
  }

  getLeave() {
    this.leaveService.getLeave(this.id);
    this.leaveService.leaveSubject.subscribe(
      (data : any)=>{
        if(data.status =='200'){
          this.leave = data.leaveEnvelop;
          this.fetchUserDataForAbsences();
          this.detailLoading=false;   
        }
      },
      (error :any) => {
      }
    )
  }
  
  fetchUserDataForAbsences() {
    const commercialId = this.leave.commercialId; 
      this.userService.getUserFilteredData(commercialId, ['fullName', 'avatar']).subscribe(
        (userData: any) => {
          if (userData) {
            this.leave.fullname = userData.connected_user.user_fullname;
            this.leave.avatar = userData.connected_user.user_avatar;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);        }
      );
  }

  downloadPicture(event:any,absence:any,base:any){
    if(event.target != null){
      var dateabsence = JSON.stringify(absence.start).slice(0,11)
      event.target!.setAttribute('href', 'data:image/jpg;base64,' + base);
      event.target!.setAttribute('download', 'absence_' +absence.type+"_"+absence.fullname+"_"+dateabsence+'.jpg');
    }
  }

  hoveredFile: any = null;

  showImage(file: any) {
      file.base64Image = 'data:image/png;base64,' + file.file;
      this.hoveredFile = file;
  }

  hideImage() {
      this.hoveredFile = null;
  }
}
